const  job_data=[
    {
        "uuid":"898w9182098",
        "companyId":"91928489180324",
        "Job Title":"ABC TEST ETSTES",
        "Department":"Science",
        "Work Style":"Remote",
        "Posted Date":"7-9-10",
        "Close Date":"8-10-20",
        "Applications":"3",
        "Selected":"10",
        "interviewed":"10",
        "Status":"Active",
    },
    {
        "uuid":"898w9182098",
        "Job Title":"ABC TEST ETSTES",
        "Department":"Science",
        "Work Style":"Remote",
        "Posted Date":"7-9-10",
        "Close Date":"8-10-20",
        "Applications":"3",
        "Selected":"10",
        "interviewed":"10",
        "Status":"Active",
    },
    {
        "uuid":"898w9182098",
        "Job Title":"ABC TEST ETSTES",
        "Department":"Science",
        "Work Style":"Remote",
        "Posted Date":"7-9-10",
        "Close Date":"8-10-20",
        "Applications":"3",
        "Selected":"10",
        "interviewed":"10",
        "Status":"Active",
    },
    {
        "uuid":"898w9182098",
        "Job Title":"ABC TEST ETSTES",
        "Department":"Science",
        "Work Style":"Remote",
        "Posted Date":"7-9-10",
        "Close Date":"8-10-20",
        "Applications":"3",
        "Selected":"10",
        "interviewed":"10",
        "Status":"Active",
    },
    {
        "uuid":"898w9182098",
        "Job Title":"ABC TEST ETSTES",
        "Department":"Science",
        "Work Style":"Remote",
        "Posted Date":"7-9-10",
        "Close Date":"8-10-20",
        "Applications":"3",
        "Selected":"10",
        "interviewed":"10",
        "Status":"Active",
    }
]

const dummy_notifications = [
    {
        "name":"Assign Interviewer for Round 2",
        "date":"20 Aug 24",
        "subtext":"[Candidate Name] moved from AI interview to round 2 for [Job Title]. Assign interviewer and schedule date."
    },
    {
        "name":"Assign Interviewer for Round 2",
        "date":"20 Aug 24",
        "subtext":"[Candidate Name] moved from AI interview to round 2 for [Job Title]. Assign interviewer and schedule date."
    },
    {
        "name":"Assign Interviewer for Round 2",
        "date":"20 Aug 24",
        "subtext":"[Candidate Name] moved from AI interview to round 2 for [Job Title]. Assign interviewer and schedule date."
    },
    {
        "name":"Assign Interviewer for Round 2",
        "date":"20 Aug 24",
        "subtext":"[Candidate Name] moved from AI interview to round 2 for [Job Title]. Assign interviewer and schedule date."
    },
    {
        "name":"Assign Interviewer for Round 2",
        "date":"20 Aug 24",
        "subtext":"[Candidate Name] moved from AI interview to round 2 for [Job Title]. Assign interviewer and schedule date."
    },
    {
        "name":"Assign Interviewer for Round 2",
        "date":"20 Aug 24",
        "subtext":"[Candidate Name] moved from AI interview to round 2 for [Job Title]. Assign interviewer and schedule date."
    },
    
]

const documents=[
    {
        "documentName":"Aadhar Card",
        "uploadedBy":"Candidate1",
        "uploadedDate":"12 May 2024",
        "uploadedBy":"Candidate1",
        "uploadedDate":"12 May 2024",
        "currentStatus":"Under Review",
        "path":"https://www.google.com"
    },
    {
        "documentName":"Aadhar Card",
        "uploadedBy":"Candidate2",
        "uploadedDate":"12 May 2024",
        "currentStatus":"Not Submitted",
        "path":"https://www.google.com"
    },
    {
        "documentName":"Aadhar Card",
        "uploadedBy":"Candidate3",
        "uploadedDate":"12 May 2024",
        "currentStatus":"Verified",
        "path":"https://www.google.com"
    },
    {
        "documentName":"Aadhar Card",
        "uploadedBy":"Candidate",
        "uploadedDate":"12 May 2024",
        "currentStatus":"Rejected",
        "path":""
    },
    {
        "documentName":"Aadhar Card",
        "uploadedBy":"Candidate4",
        "uploadedDate":"12 May 2024",
        "currentStatus":"Not Submitted",
        "path":""
    },
]

const candidate_data=[
    {
        "jobID":"898w9182098",
        "ApplicantName":"Burgundy Thakur",
        "ResCom":"123",
        "AIScore":"123",
        "VAScore":"123",
        "NovScore":"123",
        "Status":"Shortlisted",
    }
]

const user_data = [
    {
        "companyId":"91928489180324",
        "name":"Ben10 Manoj",
        "email":"abc@gmail.com",
        "role":"Recruiter",
        "access":"Editor",
        "status":"active",

    }
]

const email_templates =[
    {
        "templateName":"Email Template",
        "Subject":"Subject",
        "Category":"Interview",
        "Body":"This is a email template."
    }
]

const job_templates =[
    {
        "jobtitle":"Job Titile",
        "jobDescription":"Job Description",
        "dept":"Department",

    }
]


export  {job_data, candidate_data, dummy_notifications, user_data, email_templates, job_templates, documents}